type QueryCacheState = {
  isLoading: boolean;
  data: unknown;
};

/** True only while a query has no cached data yet (not on background refetches). */
export function isQueryCacheMissing(query: QueryCacheState): boolean {
  return query.isLoading && query.data === undefined;
}
